import { useEffect, useState } from "react";
import { apiCallSPPost, apiExportToExcel } from "src/_apiConfig/apiCall";
import Auth from "src/auth";
import SearchFilter from "../Component/searchFilter";
import { SearchFilterModel } from "../Component/SearchFilterModel";
import { updateSearchStatus } from "src/views/common/CommonSearch";
import CommonList from "src/views/common/CommonList";

const PBSMSPaymentReceivedDistrictWiseDetailReport = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage

  const [search, setSearch] = useState(SearchFilterModel); // Search Model

  // Page  API URL manage
  const ReportListUrl = `Report/PBSMS/PaymentReceived/DetailedReport/District`;
  const ReportListCountUrl = `Report/PBSMS/PaymentReceived/DetailedReport/District/count`;
  const ReportListExcelUrl = `Report/PBSMS/PaymentReceived/DetailedReport/District/ExportToExcel`;
  const ReportListExcelFileName = "PBSMSPaymentReceivedDistrictWiseDetailedReport.xls";

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      collection_season: Number(search.collectionSeason),
      tenderNo: search.tenderNo.trim(),
      circle_id: Number(authenticated.role === "CFO"?authenticated.district : search.circleId),
      district_id: Number(search.disctrictId),
      lot_no: search.lotNo.trim(),
      quantity_differ_id: Number(search.quantityDifferenceId),
      payment_types: Number(search.paymentTypes),
    });
  };


  useEffect(() => {
  if (authenticated) {

    // CFO Login
    if (authenticated.role === "CFO") {

      setSearch((prev) => ({
        ...prev,
        circleId: authenticated.district, // or authenticated.district if that stores circle
      }));
    }

    // DFO Login
    if (authenticated.role === "DFO") {

      setSearch((prev) => ({
        ...prev,
        disctrictId: authenticated.district,
      }));
    }
  }
}, [authenticated]);

  useEffect(() => {
    setloading(true);
    reset();
    getReportCount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getReportList();
      getReportCount();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // get Report List
  const getReportList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();

      await apiCallSPPost(ReportListUrl, getdata(), [])
        .then((res) => {
          if (res.success) {
            setUsersData(res.data);

            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else setUsersData();
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  // get Report List Count
  const getReportCount = async () => {
    if (authenticated) {
      await apiCallSPPost(ReportListCountUrl, getdata(0, 0), 0).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
        else paggingManage(0, false);
      });
    }
  };
  // get Report List ExportToExcel
  const ExportToExcel = async () => {
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        ReportListExcelUrl,
        getdata(0, 0),
        ReportListExcelFileName
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUsersData();
  };

  //Search Filter Manage ( UI also)
  let additional = (
    <SearchFilter
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isExporting={isExporting}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      ExportToExcel={ExportToExcel}
      searchQtyDifferDisplay={true}
      searchPaymentTypesDisplay={true}
        searchCircleDisplay = {authenticated.role === "CGMF"?true:false}
    />
  );

  const fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    // {
    //   key: "circleName",
    //   _style: { width: "15%" },
    //   label: "Circle",
    // },
    {
      key: "districtName",
      _style: { width: "15%" },
      label: "District Union",
    },
    {
      key: "totalNoOfLots",
      _style: { width: "10%" },
      label: "Total No. of Lots",
    },
 
    {
      key: "approx10PerEMD",
      _style: { width: "10%" },
      label: "Approx EMD (10%) ",
    },
    {
      key: "actual10PerEMD",
      _style: { width: "10%" },
      label: " Actual EMD (10%) ",
    },
    {
      key: "approx15PerSD",
      _style: { width: "10%" },
      label: "Approx Security Deposit (15%)",
    },
    {
      key: "actual15PerSD",
      _style: { width: "10%" },
      label: "Actual Security Deposit (15%)",
    },
    {
      key: "sD15PerPaid",
      _style: { width: "10%" },
      label: "Security Deposit Paid Online(15%)",
    },
  
       {
      key: "sD15PerPaidBG",
      _style: { width: "10%" },
      label: "Security Deposit Paid BG(15%)",
    },
    {
      key: "additionalSD100Per",
      _style: { width: "10%" },
      label: "Addl. SD Received - 100% Online",
    },
     {
      key: "additionalSD40Per",
      _style: { width: "10%" },
      label: "Addl. SD Received - 40% Online",
    },

     {
      key: "additionalSD60PerOnline",
      _style: { width: "10%" },
      label: "Addl. SD Received - 60% Online",
    },

     {
      key: "additionalSD60PerBG",
      _style: { width: "10%" },
      label: "Addl. SD Received - 60% BG",
    },
    {
      key: "godownDiff_Amount",
      _style: { width: "10%" },
      label: "Godown Diff Amount",
    },
    {
      key: "godownDiff_CGST",
      _style: { width: "10%" },
      label: "Godown Diff CGST Amount",
    },

        {
      key: "godownDiff_SGST",
      _style: { width: "10%" },
      label: "Godown Diff SGST Amount",
    },
        {
      key: "godownDiff_IGST",
      _style: { width: "10%" },
      label: "Godown Diff IGST Amount",
    },
        {
      key: "godownDiff_IncomeTax",
      _style: { width: "10%" },
      label: "Godown Diff IncomeTax Amount",
    },
        {
      key: "godownDiff_ABS",
      _style: { width: "10%" },
      label: "Godown Diff ABS Amount",
    },

        {
      key: "godownDiff_LateFees",
      _style: { width: "10%" },
      label: "Godown Diff Late Fees Amount",
    },
      {
      key: "godownDiff_FinalAmount",
      _style: { width: "10%" },
      label: "Godown Diff Final Amount Received",
    },
//=====================Full Payment =================================
  {
      key: "fullPayment_Amount",
      _style: { width: "10%" },
      label: "Full Payment Amount",
    },
{
      key: "fullPayment_CGST",
      _style: { width: "10%" },
      label: "Full Payment CGST Amount",
    },
    {
      key: "fullPayment_SGST",
      _style: { width: "10%" },
      label: "Full Payment SGST Amount",
    },
    {
      key: "fullPayment_IGST",
      _style: { width: "10%" },
      label: "Full Payment IGST Amount",
    },
    {
      key: "fullPayment_IncomeTax",
      _style: { width: "10%" },
      label: "Full Payment Income Tax Amount",
    },
    {
      key: "fullPayment_ABS",
      _style: { width: "10%" },
      label: "Full Payment ABS Amount",
    },
    {
      key: "fullPayment_RebateOnFullPayment",
      _style: { width: "10%" },
      label: "Full Payment 2% Regate Amount",
    },
    {
      key: "fullPayment_Add5",
      _style: { width: "10%" },
      label: "Full Payment Additional 5% Amount",
    },
    {
      key: "fullPayment_AdditionalSD",
      _style: { width: "10%" },
      label: "Full Payment SD Amount for Refund",
    },
    {
      key: "fullPayment_LateFees",
      _style: { width: "10%" },
      label: "Full Payment Late Fees Amount",
    },

   {
      key: "fullPayment_InstallmentAdjustementAmount",
      _style: { width: "10%" },
      label: "Full Payment Adjustment Amount by DFO",
    },

   {
      key: "fullPayment_FinalAmount",
      _style: { width: "10%" },
      label: "Full Payment Final Amount",
    },

    //========================First Installment===================


{
      key: "amt25",
      _style: { width: "10%" },
      label: "First Installment Amount",
    },
{
      key: "cgsT_25",
      _style: { width: "10%" },
      label: "First Installment CGST Amount",
    },
    {
      key: "sgsT_25",
      _style: { width: "10%" },
      label: "First Installment SGST Amount",
    },
    {
      key: "igsT_25",
      _style: { width: "10%" },
      label: "First Installment IGST Amount",
    },
    {
      key: "incomeTax_25",
      _style: { width: "10%" },
      label: "First Installment Income Tax Amount",
    },
    {
      key: "abS25",
      _style: { width: "10%" },
      label: "First Installment ABS Amount",
    },
    {
      key: "rebateOnFullPayment_25",
      _style: { width: "10%" },
      label: "First Installment 2% Rebate Amount",
    },
    {
      key: "add5_25",
      _style: { width: "10%" },
      label: "First Installment Additional 5% Amount",
    },
    {
      key: "additionalSDAmountForFinalPayment_25",
      _style: { width: "10%" },
      label: "First Installment SD Amount for Refund",
    },
    {
      key: "lateFees_25",
      _style: { width: "10%" },
      label: "First Installment Late Fees Amount",
    },

   {
      key: "installmentAdjustementAmount_25",
      _style: { width: "10%" },
      label: "First Installment Adjustment Amount by DFO",
    },

   {
      key: "final25",
      _style: { width: "10%" },
      label: "First Installment Final Amount",
    },

//===============Second Installment=======================

{
      key: "amt50",
      _style: { width: "10%" },
      label: "Second Installment Amount",
    },
{
      key: "cgsT_50",
      _style: { width: "10%" },
      label: "Second Installment CGST Amount",
    },
    {
      key: "sgsT_50",
      _style: { width: "10%" },
      label: "Second Installment SGST Amount",
    },
    {
      key: "igsT_50",
      _style: { width: "10%" },
      label: "Second Installment IGST Amount",
    },
    {
      key: "incomeTax_50",
      _style: { width: "10%" },
      label: "Second Installment Income Tax Amount",
    },
    {
      key: "abS50",
      _style: { width: "10%" },
      label: "Second Installment ABS Amount",
    },
    {
      key: "rebateOnFullPayment_50",
      _style: { width: "10%" },
      label: "Second Installment 2% Rebate Amount",
    },
    {
      key: "add5_50",
      _style: { width: "10%" },
      label: "Second Installment Additional 5% Amount",
    },
    {
      key: "additionalSDAmountForFinalPayment_50",
      _style: { width: "10%" },
      label: "Second Installment SD Amount for Refund",
    },
    {
      key: "lateFees_50",
      _style: { width: "10%" },
      label: "Second Installment Late Fees Amount",
    },

   {
      key: "installmentAdjustementAmount_50",
      _style: { width: "10%" },
      label: "Second Installment Adjustment Amount by DFO",
    },

   {
      key: "final50",
      _style: { width: "10%" },
      label: "Second Installment Final Amount",
    },

//==================================================

{
      key: "amt75",
      _style: { width: "10%" },
      label: "Third Installment Amount",
    },
{
      key: "cgsT_75",
      _style: { width: "10%" },
      label: "Third Installment CGST Amount",
    },
    {
      key: "sgsT_75",
      _style: { width: "10%" },
      label: "Third Installment SGST Amount",
    },
    {
      key: "igsT_75",
      _style: { width: "10%" },
      label: "Third Installment IGST Amount",
    },
    {
      key: "incomeTax_75",
      _style: { width: "10%" },
      label: "Third Installment Income Tax Amount",
    },
    {
      key: "abS75",
      _style: { width: "10%" },
      label: "Third Installment ABS Amount",
    },
    {
      key: "rebateOnFullPayment_75",
      _style: { width: "10%" },
      label: "Third Installment 2% Rebate Amount",
    },
    {
      key: "add5_75",
      _style: { width: "10%" },
      label: "Third Installment Additional 5% Amount",
    },
    {
      key: "additionalSDAmountForFinalPayment_75",
      _style: { width: "10%" },
      label: "Third Installment SD Amount for Refund",
    },
    {
      key: "lateFees_75",
      _style: { width: "10%" },
      label: "Third Installment Late Fees Amount",
    },

   {
      key: "installmentAdjustementAmount_75",
      _style: { width: "10%" },
      label: "Third Installment Adjustment Amount by DFO",
    },

   {
      key: "final75",
      _style: { width: "10%" },
      label: "Third Installment Final Amount",
    },

//====================Fourth Installment========================

{
      key: "amt100",
      _style: { width: "10%" },
      label: "Fourth Installment Amount",
    },
{
      key: "cgsT_100",
      _style: { width: "10%" },
      label: "Fourth Installment CGST Amount",
    },
    {
      key: "sgsT_100",
      _style: { width: "10%" },
      label: "Fourth Installment SGST Amount",
    },
    {
      key: "igsT_100",
      _style: { width: "10%" },
      label: "Fourth Installment IGST Amount",
    },
    {
      key: "incomeTax_100",
      _style: { width: "10%" },
      label: "Fourth Installment Income Tax Amount",
    },
    {
      key: "abS100",
      _style: { width: "10%" },
      label: "Fourth Installment ABS Amount",
    },
    {
      key: "rebateOnFullPayment_100",
      _style: { width: "10%" },
      label: "Fourth Installment 2% Rebate Amount",
    },
    {
      key: "add5_100",
      _style: { width: "10%" },
      label: "Fourth Installment Additional 5% Amount",
    },
    {
      key: "additionalSDAmountForFinalPayment_100",
      _style: { width: "10%" },
      label: "Fourth Installment SD Amount for Refund",
    },
    {
      key: "lateFees_100",
      _style: { width: "10%" },
      label: "Fourth Installment Late Fees Amount",
    },

   {
      key: "installmentAdjustementAmount_100",
      _style: { width: "10%" },
      label: "Fourth Installment Adjustment Amount by DFO",
    },

   {
      key: "final100",
      _style: { width: "10%" },
      label: "Fourth Installment Final Amount",
    },

    //==================================================
    {
      key: "lotTransferFees",
      _style: { width: "10%" },
      label: "Lot Transfer Fees",
    },
    {
      key: "agreementExtentionFeess7",
      _style: { width: "10%" },
      label: "7 days Agreement Extention Fees",
    },
    {
      key: "agreementExtentionFees15",
      _style: { width: "10%" },
      label: "15 days Agreement Extention Fees",
    },
    {
      key: "godownRent",
      _style: { width: "10%" },
      label: "Godown Rent",
    },
    {
      key: "godownRentExtention",
      _style: { width: "10%" },
      label: "Godown Rent Extention",
    },
    {
      key: "lotLeftRequestFees",
      _style: { width: "10%" },
      label: "Lot Left Request Fees",
    },
    {
      key: "ahP_GodownRent",
      _style: { width: "10%" },
      label: "Adhoc Payment - GodownRent",
    },
    {
      key: "ahP_GST",
      _style: { width: "10%" },
      label: "Adhoc Payment - GST",
    },
        {
      key: "ahP_IncomeTax",
      _style: { width: "10%" },
      label: "Adhoc Payment - IncomeTax",
    },
   
       {
      key: "ahP_LateFees",
      _style: { width: "10%" },
      label: "Adhoc Payment - LateFees",
    },
         {
      key: "ahP_Installment",
      _style: { width: "10%" },
      label: "Adhoc Payment - Installment",
    },
       {
      key: "ahP_Other",
      _style: { width: "10%" },
      label: "Adhoc Payment - Other",
    },
           {
      key: "refundAmount5Per",
      _style: { width: "10%" },
      label: "Refund Amount 5Per",
    },
  ];

  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Payment Received - District Wise Detailed Report"
      loading={loading}
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      id="userid"
    />
  );
};

export default PBSMSPaymentReceivedDistrictWiseDetailReport;
